// StorePage1.tsx
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { updateForm } from "../../../redux/storeFormSlice";
import { useNavigate, useParams } from "react-router-dom";
import SubmitButton from "../../../components/form/SubmitButton";
import MainTitle from "../../../components/ui/MainTitle";
import StorePageOneForm, { Page1FormData } from "../../../components/store/createStoreForms/StorePageOneForm";
import BackButton from "../../../components/ui/BackButton";
import FileUpload from "../../../components/form/FileUpload";
import { useTranslation } from "react-i18next";

export default function StorePageOne() {
  const { ownerId} = useParams<{ ownerId: string}>();
   const numericOwnerId = ownerId ? parseInt(ownerId) : 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { commercialRegister, taxNumber, city ,commercialRegisterFile,taxNumberFile} = useSelector(
    (state: RootState) => state.storeForm
  );

  const { register, handleSubmit, setValue, formState: { errors } } = useForm<Page1FormData>({
    defaultValues: { commercialRegister, taxNumber, city }
  });

    const [commercialFile, setCommercialRegisterFile] = useState<File | null>(commercialRegisterFile);
    const [taxFile, setTaxNumberFile] = useState<File | null>(taxNumberFile);

  useEffect(() => {
    setValue("commercialRegister", commercialRegister);
    setValue("taxNumber", taxNumber);
    setValue("city", city);
  }, [commercialRegister, taxNumber, city, setValue]);

  const onNext = (data: Page1FormData) => {
    dispatch(updateForm({...data, commercialRegisterFile:commercialFile,taxNumberFile:taxFile}));
    navigate(numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page2`: "/owner/add-store/page2");
  };

  const {t} = useTranslation();

  return (
    <div className="p-6 container h-[100vh] overflow-auto">
      <form onSubmit={handleSubmit(onNext)} className="flex flex-col gap-4 w-full">
        <MainTitle title="Store Information" />
        <StorePageOneForm register={register} errors={errors} />
        <div className=" grid grid-cols-2 gap-4">
          <FileUpload
          file={commercialFile}
          setFile={setCommercialRegisterFile}
          label={""}
          addText={t("add_commercialRegister_image")}
          shape="rectangle"
          size={128}
        />

        <FileUpload
          file={taxFile}
          setFile={setTaxNumberFile}
          label={""}
          addText={t("add_taxNumber_image")}
          shape="rectangle"
          size={128}
        />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <BackButton url={numericOwnerId?`/admin/owners/${numericOwnerId}/add-store`: "/owner/add-store"} height={64} />
          <SubmitButton height={64} label={"next"} />
        </div>
      </form>
    </div>
  );
}
